import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import Report from "./components/Ekata/Report";
import store from "store-js";

function Ekata() {

  const currentTab = store.get("solrTab") || 0;
  const [selected, setSelected] = useState(currentTab);

  store.set("solrTab", selected);

  const handleTabChange = useCallback((index) => setSelected(index), []);

  const tabs = [
    {
      id: "ekataReport",
      title: "Ekata",
      content: "Report",
      page: <Report />,
      panelID: "ekataReportPanel",
    },
  ];

  return (
    <Page breadcrumbs={[{ url: "/" }]} title={tabs[selected].title} fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}

export default Ekata;
